// extracted by mini-css-extract-plugin
module.exports = {"img":"contactTop_img__DrIYD"};